/**
 * Voice Agenda Builder — first-assistant message (welcome).
 *
 * Copy is fixed; bundled audio in `web-dashboard/public/audio/voice-agenda-welcome.wav`
 * is generated from this exact string (`web-dashboard/scripts/generate-voice-agenda-welcome-audio.sh`).
 */

export const VOICE_AGENDA_WELCOME_MESSAGE =
  "Welcome. Let's set up your meeting agenda. If you prefer speaking, press the Start Mic button. When you're done with each step, say finished, done, or send to save your work. If you want to clear the current response, say start over or delete. I'm ready when you are.";
